export enum VignetteModules {
  FEDERAL_POLICYMAKERS = 1,
  STATE_POLICYMAKERS = 2,
  FEDERAL_INFLUENCERS = 3,
  STATE_INFLUENCERS = 4,
}
